// extracted by mini-css-extract-plugin
module.exports = {"dialogInfo":"InfoDialog_dialogInfo__37IEH","info":"InfoDialog_info__29GF8","actions":"InfoDialog_actions__2w_iq"};